// extracted by mini-css-extract-plugin
export default {"events-root-container":"EventsRoot_events-root-container__XV2k+"};